module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_0.d7b65906.png";